import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import values from 'lodash.values';
import classNames from 'classnames';
import {categoryHref} from 'lib/categories';
import ContactLink from './ContactLink';
import styles from './nav.module.scss';
import logo from './logo.png';

class Nav extends Component {
  state = {
    isActive: false,
  };

  componentDidMount = () => {
    window.addEventListener('scroll', this.dismiss);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.dismiss);
  };

  blockScroll = e => {
    e.preventDefault();
  };

  dismiss = () => {
    const {isActive} = this.state;
    if (isActive) {
      this.setState({isActive: false});
    }
  };

  toggleActive = () => {
    const {isActive} = this.state;
    this.setState({isActive: !isActive});
  };

  render() {
    const {articleTree, centerRight} = this.props;
    const {isActive} = this.state;

    return (
      <nav
        className={classNames('navbar container is-shadowless', styles.Nav)}
        role="navigation"
      >
        <div className="navbar-brand">
          <Link to="/">
            <img alt="Logo" className={styles.Nav__logo} src={logo} />
          </Link>
          <a
            aria-expanded="false"
            aria-label="menu"
            className={classNames(
              'navbar-burger has-text-white',
              styles.Nav__burger,
              {
                'is-active': isActive,
              }
            )}
            onClick={this.toggleActive}
            role="button"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          className={classNames('navbar-menu', styles.Nav__menu, {
            'is-active': isActive,
          })}
          onTouchMove={this.blockScroll}
          onWheel={this.blockScroll}
        >
          <div className="navbar-item has-dropdown is-hoverable">
            <Link
              className={classNames('navbar-link', styles.Nav__rootItem)}
              to="/article/77-welcome-to-teamgantt"
            >
              Help Docs
            </Link>

            <div
              className={classNames('navbar-dropdown', styles.Nav__dropdown)}
            >
              {values(articleTree).map(category => (
                <Link
                  className={classNames(
                    'navbar-item has-text-dark',
                    styles.Nav__dropdownItem
                  )}
                  key={category.id}
                  to={categoryHref(category)}
                >
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
          <Link
            className={classNames('navbar-item', styles.Nav__rootItem)}
            to="/videos"
          >
            Videos
          </Link>
          <a
            className={classNames(
              'navbar-link',
              styles.Nav__mobileItem,
              styles.Nav__rootItem
            )}
            href="https://app.teamgantt.com/login"
          >
            Login
          </a>
          <ContactLink
            buttonClassName={classNames(styles.Nav__mobileItem)}
            buttonSize="large"
            inverted={false}
          />
        </div>
        <div
          className={classNames(styles.Nav__right, {
            [styles['Nav__right--centered']]: centerRight,
          })}
        >
          <a
            className={classNames('navbar-item', styles['navbar-item'])}
            href="https://app.teamgantt.com/login"
          >
            Login
          </a>
          <ContactLink />
        </div>
      </nav>
    );
  }
}

Nav.propTypes = {
  articleTree: PropTypes.objectOf(PropTypes.object).isRequired,
  centerRight: PropTypes.bool,
};

Nav.defaultProps = {
  centerRight: false,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/header/Nav.js